module.exports = __webpack_public_path__ + "static/media/fpl_teamID.b05beae9.png";